<template>
  <div class="query-page">
    <section class="filter-panel">
      <div class="filter-title"><strong>筛选条件</strong><span>设备 ID 和检测员 ID 至少填写一项</span></div>
      <div class="filter-grid log-filter-grid">
        <label class="filter-item">
          <el-input
              placeholder="请输入设备ID"
              class="copyable-device-id"
              v-model="searchParams.deviceId"
              size="large"
              @keyup.enter="searchDeviceLog"
              clearable
          >
          </el-input>
        </label>
        <label class="filter-item">
          <el-input
              placeholder="请输入检测员ID"
              v-model="searchParams.inspectorId"
              size="large"
              @keyup.enter="searchDeviceLog"
              clearable
          >
          </el-input>
        </label>
        <label class="filter-item">
          <el-date-picker
              v-model="searchParams.begin"
              type="date"
              placeholder="开始日期"
              size="large"
              :picker-options="pickerOptions"
              clearable
          >
          </el-date-picker>
        </label>
        <label class="filter-item">
          <el-date-picker
              v-model="searchParams.end"
              type="date"
              placeholder="结束日期"
              size="large"
              :picker-options="pickerOptions"
              clearable
          >
          </el-date-picker>
        </label>
      </div>
      <div class="filter-actions">
        <el-button type="primary" size="large" @click="searchDeviceLog">查询日志数据</el-button>
        <el-button type="success" size="large" plain @click="exportWaterData" :disabled="!deviceLogData || deviceLogData.length === 0">
          导出日志数据
        </el-button>
      </div>
    </section>

    <section class="table-panel">
      <div class="table-heading"><div><h3>日志列表</h3><p>共 {{ pageParams.total }} 条日志</p></div></div>
      <el-table
        :data="deviceLogData"
        style="width: 100%; table-layout: auto;"
        :row-class-name="tableRowClassName"
        :header-cell-style="{textAlign: 'center', whiteSpace: 'nowrap'}"
        :cell-style="{textAlign: 'center', whiteSpace: 'nowrap'}"
    >
      <el-table-column prop="id" label="ID" min-width="50" max-width="120"></el-table-column>
      <el-table-column prop="deviceId" label="设备ID" min-width="50" max-width="200"></el-table-column>
      <el-table-column prop="logType" label="日志类型" min-width="50" max-width="120"></el-table-column>
      <el-table-column prop="logData" label="日志内容" min-width="50" max-width="200">
        <template #default="scope">
          <div v-if="scope && scope.row && scope.row.logData">
            {{ scope.row.logData }}
          </div>
          <div v-else class="text-gray-400">无内容</div>
        </template>
      </el-table-column>
      <el-table-column prop="logTime" label="日志时间" min-width="50" max-width="220"></el-table-column>
      </el-table>
      <div class="pagination-bar">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageParams.total"
          :current-page="pageParams.current"
          :page-size="pageParams.pageSize"
      >
      </el-pagination>
      </div>
    </section>
  </div>
</template>

<script>
import {exportLogData, fetchDeviceLogData} from "@/api/deviceLog";
import {ElMessage} from "element-plus";
import { API_BASE_URL } from '@/config';
import { readExcelExportResponse } from '@/utils/excelExportResponse';

export default {
  data() {
    return {
      searchParams: {
        deviceId: "", // 设备ID
        inspectorId: "", // 检测员ID
        begin: "", // 开始时间
        end: "", // 结束时间
      },
      deviceLogData: [],
      pageParams: {
        current: 1, // 当前页
        pageSize: 10, // 每页大小
        total: 0, // 总记录数
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  computed: {
    hasMorePages() {
      return this.pageParams.current * this.pageParams.pageSize < this.pageParams.total;
    },
  },
  methods: {
    exportLogData,
    handleSizeChange(val) {
      this.pageParams.pageSize = val;
      this.pageParams.current = 1; // 切换每页数量时回到第一页
      this.searchDeviceLog();
    },

    handleCurrentChange(val) {
      this.pageParams.current = val;
      this.searchDeviceLog();
    },

    async searchDeviceLog() {
      // 验证设备ID或检测员ID至少有一个不为空
      if (!this.searchParams.deviceId && !this.searchParams.inspectorId) {
        this.$message.warning("设备ID和检测员ID至少传入一个");
        return;
      }

      // 检查开始日期是否晚于结束日期
      if (this.searchParams.begin && this.searchParams.end) {
        const beginDate = new Date(this.searchParams.begin);
        const endDate = new Date(this.searchParams.end);
        if (beginDate > endDate) {
          this.$message.warning("开始日期不能晚于结束日期");
          return;
        }
      }

      // 构建请求参数
      const requestData = {
        current: this.pageParams.current, // 传递当前页
        pageSize: this.pageParams.pageSize, // 传递每页数量
      };

      // 如果选择了设备ID，添加到请求参数
      if (this.searchParams.deviceId) {
        requestData.deviceId = this.searchParams.deviceId;
      }

      // 如果选择了检测员ID，添加到请求参数
      if (this.searchParams.inspectorId) {
        requestData.inspectorId = this.searchParams.inspectorId;
      }

      // 如果选择了开始日期，添加到请求参数
      if (this.searchParams.begin) {
        requestData.begin = this.searchParams.begin;
      }

      // 如果选择了结束日期，添加到请求参数
      if (this.searchParams.end) {
        requestData.end = this.searchParams.end;
      }

      try {
        const response = await fetchDeviceLogData(requestData);

        if (response.data && response.data.records) {
          // 保存原始的总记录数
          this.pageParams.total = response.data.total;

          // 处理日志时间过滤
          let filteredRecords = response.data.records;

          // 如果设置了开始日期，过滤早于开始日期的日志
          if (this.searchParams.begin) {
            const beginDate = new Date(this.searchParams.begin);
            filteredRecords = filteredRecords.filter(record => {
              const logDate = new Date(this.formatTimestamp(record.timestamp));
              return logDate >= beginDate;
            });
          }

          // 如果设置了结束日期，过滤晚于结束日期的日志
          if (this.searchParams.end) {
            const endDate = new Date(this.searchParams.end);
            // 设置结束日期的时间为23:59:59，以便包含当天所有时间
            endDate.setHours(23, 59, 59, 999);
            filteredRecords = filteredRecords.filter(record => {
              const logDate = new Date(this.formatTimestamp(record.timestamp));
              return logDate <= endDate;
            });
          }

          // 应用过滤后的记录
          this.deviceLogData = filteredRecords.map((item) => ({
            ...item,
            logTime: this.formatTimestamp(item.timestamp),
            logData: item.logData,
          }));

          // 如果查询结果为空，提示用户
          if (filteredRecords.length === 0) {
            this.$message.info("未查询到符合条件的日志数据");
          }
        } else {
          this.$message.info("未查询到日志数据");
          this.deviceLogData = [];
          this.pageParams.total = 0;
        }
      } catch (error) {
        console.error("查询日志数据失败:", error);
        this.$message.error("查询数据失败，请稍后再试");
      }
    },

    // 导出日志数据
    async exportWaterData() {
      // 校验：必须有查询结果才能导出
      if (!this.deviceLogData || this.deviceLogData.length === 0) {
        ElMessage.warning("没有数据可导出，请先查询数据");
        return;
      }

      // 准备导出参数（使用当前查询条件）
      const exportParams = {
        deviceId: this.searchParams.deviceId,
        inspectorId: this.searchParams.inspectorId,
        begin: this.searchParams.begin,
        end: this.searchParams.end,
        // 导出全部数据，不使用分页（根据后端接口调整）
        // 注意：如果后端接口不支持不分页，可能需要调整为获取所有页数据
        pageSize: this.pageParams.total > 10000 ? 10000 : this.pageParams.total // 限制最大导出数量
      };

      try {
        // 显示加载状态
        ElMessage.info("正在准备数据，请稍候...");

        // 调用导出API（使用已有的exportWaterData函数）
        // const response = await exportWaterData(exportParams);

        const token = localStorage.getItem('token');
        const response = await fetch(`${API_BASE_URL}/api/web/devicelog/export`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'token': token, // 使用后端期望的 token 头
          },
          body: JSON.stringify(exportParams),
          responseType: 'blob', // 关键配置：告知浏览器接收二进制流
        });

        // 创建Blob对象
        // const blob = new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
        // 关键步骤：通过 response.blob() 获取 Blob 对象
        //处理Blob响应
        const blob = await readExcelExportResponse(response);
        // console.log('@@@@@@@@@blob类型:', blob instanceof Blob); // 应输出 true
        // console.log('@@@@@@@@@blob.size:', blob.size); // 应显示正确大小
        // 创建下载链接
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);

        // 设置文件名（包含时间戳，避免重复）
        const date = new Date();
        const formattedDate = date.getFullYear() +
            String(date.getMonth() + 1).padStart(2, '0') +
            String(date.getDate()).padStart(2, '0') + '_' +
            String(date.getHours()).padStart(2, '0') +
            String(date.getMinutes()).padStart(2, '0') +
            String(date.getSeconds()).padStart(2, '0');
        link.download = `日志数据_${formattedDate}.xlsx`;

        // 触发下载
        document.body.appendChild(link);
        link.click();

        // 清理资源
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);

        ElMessage.success("导出成功");
      } catch (error) {
        //错误处理
        console.error("导出失败:", error);

        // 处理可能的HTTP错误
        if (error.status || error.code || error.response) {
          if (error.status === 401 || error.response?.status === 401 || Number(error.code) === 1003) {
            ElMessage.error("登录状态已过期，请重新登录");
            this.$router.push({name: 'Login'});
            return;
          } else if (error.status === 403 || error.response?.status === 403 || Number(error.code) === 3001) {
            ElMessage.error("没有导出权限");
            return;
          }
        }

        ElMessage.error(error.message || "导出失败，请稍后再试");
      }
    },

    // 时间戳转北京时间函数（处理毫秒级时间戳）
    formatTimestamp(timestamp) {
      if (!timestamp) return "";
      let date;
      if (typeof timestamp === "number") {
        // 秒级时间戳（< 1e12）转为毫秒，毫秒级直接用
        date = new Date(timestamp < 1e12 ? timestamp * 1000 : timestamp);
      } else {
        // 字符串格式（ISO-8601 等）直接用 Date 解析
        date = new Date(timestamp);
      }
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },

    getCurrentDate() {
      const date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
  },
};
</script>

<style scoped>
.copyable-device-id :deep(.el-input__inner) {
  user-select: text;
  -webkit-user-select: text;
  cursor: text;
}
.query-page { color: #263b4b; }
.table-heading p { margin: 6px 0 0; color: #7a8b98; font-size: 13px; }
.filter-panel, .table-panel { padding: 22px 24px; border: 1px solid #e4eaed; border-radius: 14px; background: #fff; box-shadow: 0 7px 24px rgba(31, 61, 78, .045); }
.filter-panel { margin-bottom: 18px; }
.filter-title, .table-heading { display: flex; align-items: center; justify-content: space-between; gap: 12px; }
.filter-title { margin-bottom: 18px; }
.filter-title strong, .table-heading h3 { margin: 0; font-size: 16px; }
.filter-title span { color: #8a99a4; font-size: 12px; }
.filter-grid { display: grid; grid-template-columns: repeat(4, minmax(160px, 1fr)); gap: 18px; }
.filter-item { display: flex; min-width: 0; flex-direction: column; color: #566b79; font-size: 13px; }
.filter-item :deep(.el-date-editor) { width: 100%; }
.filter-item :deep(.el-input__wrapper) { border-radius: 9px; box-shadow: 0 0 0 1px #d8e1e5 inset; }
.filter-item :deep(.el-input__wrapper:hover) { box-shadow: 0 0 0 1px #91bbb7 inset; }
.filter-item :deep(.el-input__wrapper.is-focus) { box-shadow: 0 0 0 1px #0a7b73 inset; }
.filter-actions { display: flex; flex-wrap: wrap; gap: 10px; margin-top: 12px; }
.filter-actions :deep(.el-button + .el-button) { margin-left: 0; }
.table-heading { margin-bottom: 16px; }
.pagination-bar { display: flex; justify-content: flex-end; padding-top: 20px; overflow-x: auto; }
.text-gray-400 {
  color: #9CA3AF;
}
:deep(.el-table td), :deep(.el-table th) {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
@media (max-width: 1100px) { .filter-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); } }
@media (max-width: 620px) {
  .filter-panel, .table-panel { padding: 18px 16px; }
  .filter-grid { grid-template-columns: 1fr; gap: 14px; }
  .filter-title { align-items: flex-start; flex-direction: column; }
  .filter-actions :deep(.el-button) { flex: 1; }
}
</style>
